"use strict";
exports.__esModule = true;
var angular = require("angular");
var header_text_component_1 = require("./header-text/header-text.component");
var main_component_1 = require("./main/main.component");
var broadcast_config_1 = require("./broadcast-config");
require('./report-options.component.css');
var COMPONENT_NAME = 'smartorg.r6.navs.reportOptions2';
var ReportOptionsComponent = /** @class */ (function () {
    function ReportOptionsComponent($scope) {
        var _this = this;
        this.panelIsHidden = true;
        this.showSpinner = false;
        $scope.$on('reportOption:loaded', function (event, args) {
            _this.showSpinner = args.showSpinner;
        });
        $scope.$on(broadcast_config_1["default"].COLLAPSE, function (event, args) {
            _this.toggleReportOptionPanel(args.collapsed);
        });
    }
    ReportOptionsComponent.prototype.toggleReportOptionPanel = function (newState) {
        this.panelIsHidden = newState;
        angular.element('#reportOptionCollapsePanel').collapse(this.panelIsHidden ? 'hide' : 'show');
    };
    ReportOptionsComponent.prototype.triggerApply = function () {
        this.onApplyOptionsChange();
        this.toggleReportOptionPanel(true);
    };
    ReportOptionsComponent.prototype.updateReportOptions = function (reportOptionObj, shouldApply) {
        this.currentReportOptions = reportOptionObj;
        this.onToggleCompare({ nodeId: reportOptionObj.compareToNodeID });
        this.onApplyReportOptions({ reportOptions: reportOptionObj });
        if (shouldApply) {
            this.triggerApply();
        }
    };
    return ReportOptionsComponent;
}());
angular.module(COMPONENT_NAME, [header_text_component_1["default"], main_component_1["default"]]).component('reportOptions2', {
    template: require('./report-options.component.html'),
    bindings: {
        fixedFilters: '<?',
        /**
         * Toogle the highlighted node in tree.
         */
        onToggleCompare: '&?',
        /**
         * Set report options on workbench.
         */
        onApplyReportOptions: '&?',
        /**
         * Trigger reload action menu.
         */
        onApplyOptionsChange: '&?',
        showAlert: '&?',
        smartorgApi: '='
    },
    controller: ReportOptionsComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=report-options.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options2/report-options.component.js